"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalView = exports.ModalTitle = exports.ModalMessage = exports.ModalIcon = exports.ModalButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dsIcons = require("@olxbr/ds-icons");
var _atoms = require("../../atoms");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ModalTitle = exports.ModalTitle = (0, _styledComponents["default"])(_atoms.Text)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 20px;\n  line-height: 28px;\n  font-family: var(--font-family);\n  font-weight: 600;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.gray;
});
var ModalMessage = exports.ModalMessage = (0, _styledComponents["default"])(_atoms.Text)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 24px;\n  padding-bottom: 20px;\n  padding-top: 10px;\n  font-family: var(--font-family);\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray;
});
var ModalButton = exports.ModalButton = (0, _styledComponents["default"])(_atoms.Button)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n"])));
var ModalView = exports.ModalView = (0, _styledComponents["default"])(_atoms.View)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 5px;\n"])));
var ModalIcon = exports.ModalIcon = (0, _styledComponents["default"])(_dsIcons.CameraOff)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 12px;\n  line-height: 24px;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray;
});